import React, { useEffect } from "react";
import { Modal, Form, Input, Select, DatePicker, Row, Col } from "antd";
import dayjs from "dayjs";
import usePersonnelInfoService from "../../../../services/usePersonnelInfoService";
const { TextArea } = Input;

export const EditForeignLanguageModal = ({
  visible,
  onCancel,
  initialValues,
  knowledgeLevelOptions,
  foreignLanguageLearnedPlatformOptions,
  foreingLanguages,
}) => {
  const [form] = Form.useForm();
  const { useUpdatePersonnelForeignLanguage } = usePersonnelInfoService();
  const { mutateAsync: updatePersonnelForeignLanguage, isPending: isUpdating } =
    useUpdatePersonnelForeignLanguage();

  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue({
        foreignLanguageId: initialValues.foreignLanguage?.id,
        foreignLanguageLearnedPlatform:
          initialValues.foreignLanguageLearnedPlatform?.name,
        readingLevel: initialValues.readingLevel?.name,
        writingLevel: initialValues.writingLevel?.name,
        speakingLevel: initialValues.speakingLevel?.name,
      });
    }
  }, [visible, initialValues, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        ...values,
        id: initialValues.id,
      };
      await updatePersonnelForeignLanguage(requestBody);
      form.resetFields();
      onCancel();
    } catch (error) {
      console.error("Form validation or submission failed:", error);
    }
  };

  return (
    <Modal
      open={visible}
      title="Yabancı Dil Düzenle"
      onCancel={onCancel}
      onOk={handleSave}
      okText="Güncelle"
      confirmLoading={isUpdating}>
      <Form form={form} layout="vertical">
        <Form.Item
          name="foreignLanguageId"
          label="Yabancı Diller"
          rules={[{ required: true }]}>
          <Select
            options={foreingLanguages}
            placeholder="Yabancı Dil Seçiniz..."
          />
        </Form.Item>
        <Form.Item
          name="foreignLanguageLearnedPlatform"
          label="Öğrenilen Yer"
          rules={[{ required: true }]}>
          <Select
            options={foreignLanguageLearnedPlatformOptions}
            placeholder="Öğrenilen Yer Seçiniz..."
          />
        </Form.Item>
        {["readingLevel", "writingLevel", "speakingLevel"].map((skill) => (
          <Form.Item
            required
            key={skill}
            name={skill}
            label={
              skill === "readingLevel"
                ? "Okuma"
                : skill === "writingLevel"
                ? "Yazma"
                : "Konuşma"
            }>
            <Select options={knowledgeLevelOptions} />
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};

export const EditComputerKnowledgeModal = ({
  visible,
  onCancel,
  initialValues,
  computerInformationOptions,
  knowledgeLevelOptions,
  yearsOfExperienceOptions,
}) => {
  const [form] = Form.useForm();

  const { useUpdatePersonnelComputerInformation } = usePersonnelInfoService();
  const {
    mutateAsync: updatePersonnelComputerInformation,
    isPending: isUpdating,
  } = useUpdatePersonnelComputerInformation();

  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue({
        computerInformationId: initialValues.computerInformation?.id,
        level: initialValues.level?.name,
        yearsOfExperience: initialValues.yearsOfExperience?.name,
        description: initialValues.description,
      });
    }
  }, [visible, initialValues, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        ...values,
        id: initialValues.id,
      };
      await updatePersonnelComputerInformation(requestBody);
      form.resetFields();
      onCancel();
    } catch (error) {
      console.error("Form validation or submission failed:", error);
    }
  };

  return (
    <Modal
      open={visible}
      title="Bilgisayar Bilgisi Düzenle"
      onCancel={onCancel}
      onOk={handleSave}
      okText="Güncelle"
      confirmLoading={isUpdating}>
      <Form form={form} layout="vertical">
        <Form.Item
          name="computerInformationId"
          label="Bilgisayar Bilgisi"
          rules={[{ required: true }]}>
          <Select
            options={computerInformationOptions}
            placeholder="Bilgisayar Bilgisi Seçiniz"
          />
        </Form.Item>
        <Form.Item name="level" label="Seviye">
          <Select
            options={knowledgeLevelOptions}
            placeholder="Yetkinlik Seviyesi Seçiniz"
          />
        </Form.Item>
        <Form.Item name="yearsOfExperience" label="Tecrübe">
          <Select
            options={yearsOfExperienceOptions}
            placeholder="Tecrübe Seçiniz"
          />
        </Form.Item>
        <Form.Item name="description" label="Açıklama">
          <TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const EditCourseSeminarModal = ({
  visible,
  onCancel,
  initialValues,
}) => {
  const [form] = Form.useForm();

  const { useUpdatePersonnelCourse } = usePersonnelInfoService();
  const { mutateAsync: updatePersonnelCourse, isPending: isUpdating } =
    useUpdatePersonnelCourse();

  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue({
        courseName: initialValues.courseName,
        institutionName: initialValues.institutionName,
        date: dayjs(`${initialValues.year}-${initialValues.month}`),
        description: initialValues.description,
      });
    }
  }, [visible, initialValues, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        ...values,
        month: values.date.$M + 1,
        year: values.date.$y,
        id: initialValues.id,
      };
      await updatePersonnelCourse(requestBody);
      form.resetFields();
      onCancel();
    } catch (error) {
      console.error("Form validation or submission failed:", error);
    }
  };

  return (
    <Modal
      open={visible}
      title="Kurs/Seminer Düzenle"
      onCancel={onCancel}
      onOk={handleSave}
      okText="Güncelle"
      confirmLoading={isUpdating}>
      <Form form={form} layout="vertical">
        <Form.Item
          name="courseName"
          label="Kurs/Seminer Adı"
          rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="institutionName"
          label="Kurum Adı"
          rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Row gutter={8} style={{ width: "100%" }}>
          <Col span={18}>
            <Form.Item name="date" label="Tarih" rules={[{ required: true }]}>
              <DatePicker picker="month" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="description"
          label="Açıklama"
          rules={[{ required: true }]}>
          <TextArea placeholder="Açıklama" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const EditCertificateModal = ({ visible, onCancel, initialValues }) => {
  const [form] = Form.useForm();

  const { useUpdatePersonnelCertificate } = usePersonnelInfoService();
  const { mutateAsync: updatePersonnelCertificate, isPending: isUpdating } =
    useUpdatePersonnelCertificate();

  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue({
        certificateName: initialValues.certificateName,
        certificateNumber: initialValues.certificateNumber,
        institutionName: initialValues.institutionName,
        date: dayjs(`${initialValues.year}-${initialValues.month}`),
        description: initialValues.description,
      });
    }
  }, [visible, initialValues, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        ...values,
        month: values.date.$M + 1,
        year: values.date.$y,
        id: initialValues.id,
      };
      await updatePersonnelCertificate(requestBody);
      form.resetFields();
      onCancel();
    } catch (error) {
      console.error("Form validation or submission failed:", error);
    }
  };

  return (
    <Modal
      open={visible}
      title="Sertifika/Lisans Düzenle"
      onCancel={onCancel}
      onOk={handleSave}
      okText="Güncelle"
      confirmLoading={isUpdating}>
      <Form form={form} layout="vertical">
        <Form.Item
          name="certificateName"
          label="Sertifika/Lisans Adı"
          rules={[{ required: true }]}>
          <Input placeholder="Sertifika Adı" />
        </Form.Item>
        <Form.Item
          name="date"
          label="Alınan Tarih"
          rules={[{ required: true }]}>
          <DatePicker picker="month" />
        </Form.Item>
        <Form.Item
          name="certificateNumber"
          label="Sertifika No"
          rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="institutionName"
          label="Veren Kurum"
          rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="description"
          label="Açıklama"
          rules={[{ required: true }]}>
          <TextArea placeholder="Açıklama" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const EditExamModal = ({ visible, onCancel, initialValues }) => {
  const [form] = Form.useForm();

  const { useUpdatePersonnelExam } = usePersonnelInfoService();
  const { mutateAsync: updatePersonnelExam, isPending: isUpdating } =
    useUpdatePersonnelExam();

  useEffect(() => {
    if (visible && initialValues) {
      form.setFieldsValue({
        examName: initialValues.examName,
        date: dayjs(`${initialValues.year}-${initialValues.month}`),
        description: initialValues.description,
      });
    }
  }, [visible, initialValues, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const requestBody = {
        ...values,
        month: values.date.$M + 1,
        year: values.date.$y,
        id: initialValues.id,
      };
      await updatePersonnelExam(requestBody);
      form.resetFields();
      onCancel();
    } catch (error) {
      console.error("Form validation or submission failed:", error);
    }
  };

  return (
    <Modal
      open={visible}
      title="Sınav Düzenle"
      onCancel={onCancel}
      onOk={handleSave}
      okText="Güncelle"
      confirmLoading={isUpdating}>
      <Form form={form} layout="vertical">
        <Form.Item
          name="examName"
          label="Sınav Adı"
          rules={[{ required: true }]}>
          <Input placeholder="Sınav adı" />
        </Form.Item>
        <Row>
          <Col span={12}>
            <Form.Item name="date" label="Tarih" rules={[{ required: true }]}>
              <DatePicker picker="month" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item name="description" label="Açıklama">
          <TextArea rows={2} placeholder="Lütfen Aldığınız Puanı Giriniz" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
